import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import {
  Container,
  InputWrapper,
  Label,
  StyledInput,
  ErrorMessage,
  InputContent,
} from './styles';

const FormikLabeledInput = ({
  name,
  placeholder,
  label,
  type,
  className,
  isHalfWidth,
  endAdornment,
  isDarkTheme,
}) => (
  <Container className={className} $isHalfWidth={isHalfWidth}>
    <Field name={name}>
      {({ field, meta }) => (
        <>
          <InputWrapper
            $isDarkTheme={isDarkTheme}
            $hasError={meta.touched && meta.error}
            $filled={!!field.value}
          >
            {label && <Label htmlFor={name}>{label}</Label>}
            <InputContent>
              <StyledInput
                {...field}
                id={name}
                type={type}
                placeholder={placeholder}
                $isDarkTheme={isDarkTheme}
                $hasEndAdornment={!!endAdornment}
              />
              {endAdornment}
            </InputContent>
          </InputWrapper>
          {meta.touched && meta.error && (
            <ErrorMessage>{meta.error}</ErrorMessage>
          )}
        </>
      )}
    </Field>
  </Container>
);

FormikLabeledInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  isHalfWidth: PropTypes.bool,
  isDarkTheme: PropTypes.bool.isRequired,
  endAdornment: PropTypes.node,
};

FormikLabeledInput.defaultProps = {
  placeholder: '',
  label: '',
  type: 'text',
  className: '',
  isHalfWidth: false,
  endAdornment: null,
};

export default FormikLabeledInput;
